import { html } from "./html";

export const getYoutubeEmbedUrl = (href: string) => {
  const url = new URL(href);
  const embed = new URL("https://www.youtube.com/embed/");

  if (url.pathname.startsWith("/watch")) {
    const v = url.searchParams.get("v");
    const t = url.searchParams.get("t");

    if (v !== null) {
      embed.pathname += v;
    }

    if (t !== null) {
      embed.searchParams.append("start", t);
    }
  }

  if (url.pathname.startsWith("/shorts")) {
    const [_, __, v] = url.pathname.split("/");

    if (v !== undefined) {
      embed.pathname += v;
    }
  }

  return embed;
};

type YoutubeVideoType = "video" | "shorts";

export const getYoutubeVideoType = (href: string): YoutubeVideoType => {
  const url = new URL(href);

  if (url.pathname.startsWith("/shorts")) {
    return "shorts";
  }

  return "video";
};

export const getYoutubeIframeSize = (type: YoutubeVideoType) => {
  switch (type) {
    case "video":
      return {
        width: 560,
        height: 315,
      };
    case "shorts":
      return {
        width: 518,
        height: 922,
      };
  }
};

interface YoutubeIframeProps {
  className?: string;
  src: string;
  width: number;
  height: number;
}

export const createYoutubeIframe = ({
  className,
  src,
  width,
  height,
}: YoutubeIframeProps) => {
  return html`
    <iframe
      class="${className}"
      src="${src}"
      width="${width}"
      height="${height}"
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    />
  `;
};
